<template>
  <div class="menu" :class="showMenu ? '' : 'collapse-menu'">
    <div class="menu-scroll">
      <div class="menu-type" v-for="(val, key) in menuList" :key="key">
        <div class="title" v-show="showMenu">{{ val.title }}</div>
        <div
          class="menu-item"
          :class="[
            currentMenu &&
            currentMenu.url === item.url &&
            currentMenu.type === item.type
              ? 'active'
              : '',
            showMenu ? 'expand-item' : '',
          ]"
          v-for="item in val.list"
          :key="item.text"
          :aria-label="item.text"
          :data-track-text="item.text"
          @click="gotoUrl(item)"
          @mouseenter="changeHoverMenu(item)"
          @mouseleave="changeHoverMenu()"
        >
          <span class="menu-icon" :class="[item.icon]"></span>
          <span class="menu-name" v-show="showMenu">{{ item.text }}</span>
        </div>
      </div>
    </div>
    <button
      type="button"
      class="menu-toggle"
      :class="{ 'menu-toggle--expanded': showMenu }"
      :aria-label="showMenu ? '收起侧边导航' : '展开侧边导航'"
      :aria-expanded="String(showMenu)"
      data-track-text="展开收起菜单"
      @click="toggleMenu"
    >
      <i class="el-icon-shousuo" aria-hidden="true"></i>
      <span v-show="showMenu">收起导航</span>
    </button>
  </div>
</template>
<script>
import createWorkspaceMenu from '@/config/workspaceMenu'

export default {
  // 组件名称
  name: "Menu",
  props: {},
  // 变量声明
  data() {
    return {
      currentMenu: {},
      menuList: createWorkspaceMenu(),
      showMenu: false,
      hoverMenu: "",
    };
  },
  watch: {},
  // 实例初始化之后,进行数据侦听和事件/侦听器的配置之前同步调用
  beforeCreate() {},
  // 实例创建，挂载阶段未开始，可进行数据初始化
  created() {},
  mounted() {},
  // 方法
  methods: {
    toggleMenu() {
      this.showMenu = !this.showMenu;
      this.$emit("toggleMenu", this.showMenu ? 200 : 72);
    },
    changeHoverMenu(item) {
      this.currentMenu = item;
    },
    gotoUrl(item) {
      this.currentMenu = item;
      this.$router.push({
        path: item.type ? `${item.url}?type=${item.type}` : item.url,
      });
    },
    getIcon(item, isActive) {
      return {
        background:
          "url(" +
          require(`../../../assets/chat/menu/${item.icon}${
            isActive ? "-active" : ""
          }.png`) +
          ") center center / contain no-repeat",
      };
    },
  },
};
</script>
<style lang="less" scoped>
.menu {
  width: 200px;
  min-height: 100%;
  height: 100%;
  padding: 0;
  overflow: hidden;
  border-right: 1px solid #dce4e7;
  background: linear-gradient(180deg, #ffffff 0%, #f8fbff 100%);
  box-sizing: border-box;
  position: relative;

  .menu-scroll {
    width: 100%;
    height: 100%;
    padding: 14px 14px 62px;
    overflow-x: hidden;
    overflow-y: auto;
    box-sizing: border-box;
    scrollbar-width: thin;
    scrollbar-color: rgba(16, 185, 129, 0.24) transparent;

    &::-webkit-scrollbar {
      width: 5px;
    }

    &::-webkit-scrollbar-track {
      background: transparent;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 999px;
      background: rgba(16, 185, 129, 0.24);
    }
  }

  &.collapse-menu {
    width: 72px;
    background: #f8fbfe;

    .menu-type {
      width: 100%;
      margin-left: 0;

      & + .menu-type {
        margin-top: 0;
        padding-top: 0;

        &::before {
          display: none;
        }
      }

      .title {
        display: none;
      }

      .menu-item {
        width: 44px;
        height: 44px;
        gap: 0;
        margin: 0 auto 6px;
        padding: 0;
        justify-content: center;

        .menu-icon {
          margin-right: 0;
        }

        &.active {
          border-radius: 11px;
        }

        &::after {
          display: none;
        }
      }
    }
  }

  .menu-toggle {
    position: absolute;
    z-index: 2;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 54px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    box-sizing: border-box;
    border: 0;
    border-top: 1px solid #e3eceb;
    background: transparent;
    color: #697586;
    cursor: pointer;
    transition: color 0.16s ease, background 0.16s ease;

    i {
      width: 20px;
      height: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex: 0 0 20px;
      font-size: 18px;
      transition: transform 0.18s ease;
    }

    span {
      margin-left: 10px;
      font-size: 14px;
      font-weight: 500;
    }

    &.menu-toggle--expanded {
      justify-content: flex-start;
      padding: 0 22px;

      i {
        transform: rotate(180deg);
      }
    }

    &:hover {
      color: var(--primary);
      background: #f0f6ff;
    }

    &:focus-visible {
      color: var(--primary);
      background: #f0f6ff;
      outline: 2px solid rgba(16, 185, 129, 0.3);
      outline-offset: -3px;
    }
  }

  .menu-type {
    width: 100%;
    margin-left: 0;

    & + .menu-type {
      position: relative;
      margin-top: 8px;
      padding-top: 7px;

      &::before {
        position: absolute;
        top: 0;
        right: 8px;
        left: 8px;
        height: 1px;
        background: #edf2f7;
        content: '';
      }
    }

    .title {
      display: flex;
      align-items: center;
      gap: 8px;
      margin: 12px 8px 8px;
      color: var(--primary-dark);
      font-size: 15px;
      font-weight: 600;
      line-height: 20px;
      letter-spacing: 0.04em;

      &::before {
        width: 3px;
        height: 14px;
        flex: 0 0 3px;
        border-radius: 999px;
        background: var(--primary-gradient);
        box-shadow: 0 2px 6px rgba(0, 0, 0, 0.22);
        content: '';
      }
    }

    .menu-item {
      position: relative;
      width: 100%;
      min-width: 0;
      min-height: 42px;
      gap: 8px;
      margin-bottom: 4px;
      padding: 0 8px;
      display: flex;
      align-items: center;
      cursor: pointer;
      overflow: hidden;
      color: #425466;
      border: 1px solid transparent;
      border-radius: 9px;
      background: transparent;
      box-sizing: border-box;
      transition: color 0.16s ease, border-color 0.16s ease, background 0.16s ease, box-shadow 0.16s ease, filter 0.16s ease;

      &.expand-item {
        width: 100%;
      }

      &::after {
        width: 5px;
        height: 5px;
        flex: 0 0 5px;
        margin-left: auto;
        opacity: 0;
        border-top: 1.5px solid currentColor;
        border-right: 1.5px solid currentColor;
        content: '';
        transform: rotate(45deg);
        transition: opacity 0.16s ease;
      }

      &:not(.active):hover,
      &:not(.active):focus-visible {
        color: var(--primary-dark);
        border-color: rgba(16, 185, 129, 0.2);
        background: rgba(16, 185, 129, 0.08);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);

        .menu-icon {
          color: var(--primary);
        }
      }

      &:hover::after,
      &:focus-visible::after,
      &.active::after {
        opacity: 0.8;
      }

      &:focus-visible {
        outline: 2px solid rgba(16, 185, 129, 0.3);
        outline-offset: 1px;
      }

      &.active {
        color: #ffffff;
        background: var(--primary-gradient);
        box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
        font-weight: 600;

        .menu-icon {
          color: #ffffff;
        }

        .menu-name {
          color: #ffffff;
          font-weight: 600;
        }
      }

      &.active:hover {
        box-shadow: 0 8px 20px rgba(0, 0, 0, 0.25);
      }

      &:active {
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.14);
        filter: brightness(0.96);
      }

      .menu-icon {
        width: 18px;
        height: 18px;
        flex: 0 0 18px;
        margin: 0;
        display: inline-block;
        vertical-align: middle;
        color: #7b8da1;
        font-size: 16px;
        transition: color 0.16s ease;
      }

      .menu-name {
        min-width: 0;
        flex: 1 1 auto;
        overflow: hidden;
        color: inherit;
        font-size: 14px;
        font-weight: 500;
        line-height: 40px;
        text-overflow: ellipsis;
        white-space: nowrap;
        vertical-align: middle;
        transition: color 0.16s ease;
      }
    }
  }
}
</style>
